/**
 * @desc 导入库位信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/warehousePosition/importPositionInfoList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
